import { FC, useMemo } from 'react';

import { IActiveIngestion } from 'Modules/Studio/components/StudioInfo/redux/ingestion.interface';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import { TIngestionMode } from '../../IngestionByDataSource.constants';
import DSViewIngestionByDataSourceButton from './DSViewIngestionByDataSourceButton';
import TableViewIngestionByDataSourceButton from './TableViewIngestionByDataSourceButton';
import TableViewIngestionByTableButton from './TableViewIngestionByTableButton';

type TProps = {
  listItem: IDataSourceItem;
  activeIngestion: IActiveIngestion | null;
  mode: TIngestionMode;
};

const IngestionButtonByUseCase: FC<TProps> = ({ listItem, activeIngestion, mode }) => {
  /**
   * Returns the appropriate ingestion button based on the use case
   */
  const buttonByUseCase = useMemo(() => {
    switch (mode) {
      case 'DSViewDataSource':
        return (
          <DSViewIngestionByDataSourceButton id={listItem.id} activeIngestion={activeIngestion} />
        );

      case 'TableViewDataSource':
        return (
          <TableViewIngestionByDataSourceButton
            id={listItem.id}
            activeIngestion={activeIngestion}
          />
        );

      case 'table':
        return (
          <TableViewIngestionByTableButton
            {...{
              id: listItem.id,
              name: listItem.name,
              activeIngestion,
              mode,
            }}
          />
        );

      default:
        return null;
    }
  }, [mode, listItem, activeIngestion]);

  return buttonByUseCase;
};

export default IngestionButtonByUseCase;
